export const siteConfig = {
  name: "YUMA",
  shortName: "YUMA",
  storeId:3,
  // 
  // websiteKey: "el_hatab" as const,
  websiteKey: "yuma" as const,
  url: process.env.NEXT_PUBLIC_SITE_URL ?? "https://yuma-homz.com",
  description:
    "YUMA — أثاث حديث مريح وجميل. اكتشف مجموعتنا من الأثاث المعاصر والمطابخ والديكورات بروح playful و premium. تسوق الآن.",
  ogImage: "/Office%20Furniture/image-removebg-preview.png",
  logoPath: "/Office%20Furniture/image-removebg-preview.png",
  supportEmail: "yuma@big-egypt.com",
  supportPhone: "01144144800",
  supportAddress:
    "القليوبية - بنها - حي الفلل - 196 عمارة غاز مصر - الدور الرابع - شارع 4",
  keywords: [
    "YUMA",
    "أثاث حديث",
    "أثاث مريح",
    "أثاث جميل",
    "أثاث مصري",
    "غرف نوم",
    "مطابخ حديثة",
    "صالونات",
    "أثاث خارجي",
    "ديكور منزلي",
    "أثاث premium",
    "يوما",
    "يوما للاثاث المنزلي",
    "اثاث منزلي ",
  ],
  navigation: [
    { href: "/", label: "الرئيسية" },
    { href: "/categories", label: "الأقسام" },
    { href: "/products", label: "الأثاث" },
    { href: "/orders", label: "طلباتي" },
    // { href: "/wishlist", label: "المفضلة" },
    // {
    // href: "/offers",
    // label: "العروض",
    // children: [
    //   { href: "/products?offer=daily", label: "العروض اليومية" },
    //   { href: "/products?offer=offers", label: "عروض الأثاث" },
    //   { href: "/products?offer=packages", label: "باكدج الأثاث" },
    // ],
    // },
  ],
  links: {
    facebook:
      "https://www.facebook.com/profile.php?id=61590790884901&locale=ar_AR",
    instagram:
      "https://www.instagram.com/_yumafurniture?igsh=a2ZlY3pxNHBhdXR4",
    whatsapp: "https://wa.me/201144144800",
    telegram: "",
  },
} as const;

export type SiteConfig = typeof siteConfig;
